<template>
  <div>
    <ApexChart
      :element="`chart-availability-yearly-${element}`"
      :chartOption="chartFleetAvailability"
    />
  </div>
</template>
<script>
export default {
  props: {
    series: {
      type: Array,
      default: () => {
        return []
      }
    },
    element: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chartFleetAvailability: {
        series: this.series,
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        },
        chart: {
          height: 350,
          type: 'line',
          stacked: false,
          zoom: {
            enabled: false
          }
        },
        stroke: {
          width: [0, 0, 0, 5, 5, 5]
        },
        plotOptions: {
          bar: {
            columnWidth: '90%',
            dataLabels: {
              position: 'center',
              hideOverflowingLabels: true
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px'
          },
          formatter: function (val, opts) {
            // Hanya tampilkan label pada series pertama (Actual Availability)
            if ([3, 4, 5].includes(opts.seriesIndex)) {
              return val
            }
          }
        },
        legend: {
          show: true,
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return val + '%' // memformat label sumbu y menjadi persentase
            },
          },
          max: 100, // set nilai maksimum pada sumbu y
          tickAmount: 5,
        },
        tooltip: {
          shared: false,
          intersect: true,
          y: {
            formatter: function (val) {
              return val + '%'
            }
          }
        }
      }
    }
  }
}
</script>
